import React, { useContext } from "react";
import { observer } from "mobx-react-lite";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { WithdrawalContext } from "@state/context/payment/WithdrawalContext";

export default observer(function WithdrawalPaymentMethodFilterSection() {
	const { register } = useFormContext();

	const { userPaymentMethods } = useContext(WithdrawalContext);

	const { t } = useTranslation("payment");

	return (
		<div className="form__group">
			<label htmlFor="MethodId" className="label">
				{t<string>("COMMON.PAYMENT_METHOD")}
			</label>
			<select
				id="wpaymentMethodId"
				className="input input--med input--select"
				{...register("paymentMethodId")}
			>
				<option key="paymentMethod-all" value="all">
					{t<string>("COMMON.ALL_METHODS")}
				</option>
				{userPaymentMethods?.map(
					(paymentMethod: {
						paymentMethodId: string;
						displayName: string;
					}) => (
						<option
							key={paymentMethod.paymentMethodId}
							value={paymentMethod.paymentMethodId}
						>
							{paymentMethod.displayName}
						</option>
					)
				)}
			</select>
		</div>
	);
});
